/*
 * Format a date in MM/DD/YYYY.
 * Null dates should default to an empty string,
 * Unix epoch dates should default to '---'.
 */
export const formatDate = str => {
  const d = new Date(str)
  if (isNaN(d)) return ''
  if (d.getFullYear() < 1970) return '---'
  return `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`
}

export const formatSearchFilters = filters => {
  const formatStr = str => str.split('_').map(word => {
    const [first, ...rest] = word
    return `${first.toUpperCase()}${rest.join('')}`
  }).join(' ')

  const values = Object.keys(filters).map(key => {
    const ignored = ['bounds', 'map_center', 'map_zoom', 'saved_search_id', 'sort_by', 'sort_dir']
    if (ignored.includes(key)) return null

    if (key === 'use_bounds') {
      return 'Search In Map'
    }
    if (key === 'polygons') {
      return 'Polygon Map Filter'
    }

    const label = formatStr(key)

    let value = filters[key]
    if (!value) {
      return null
    }
    if (value.join) {
      value = value.join(', ')
    } else if (typeof value === 'object') {
      value = [ ...new Set(Object.values(value)) ].join(', ')
    }

    return value && `${label}: ${value}`
  })
  return values.filter(n => n).join(' / ')
}

export function pluralize(singular, plural, amount) {
  if (typeof amount === 'undefined') {
    amount = plural
    plural = `${singular}s`
  }
  return amount === 1 ? singular : plural
}

export function abbrNum(numStr) {
  const num = Number(numStr)
  let abbr = ''

  // 10M
  if (num >= 10000000) {
    abbr = Math.round(num / 1000000) + 'M'
  }

  // 1.1M
  else if (num >= 1000000) {
    abbr = (num / 1000000).toFixed(1) + 'M'
  }

  // 100K
  else if (num >= 100000) {
    abbr = Math.round(num / 1000) + 'K'
  }

  // 10K
  else if (num >= 10000) {
    abbr = Math.round(num / 1000) + 'K'
  }

  // 1.1K
  else if (num >= 1000) {
    abbr = (num / 1000).toFixed(1) + 'K'
  }

  // Less than 1000
  else {
    abbr = String(num)
  }

  return abbr.replace(/\.0\d*/, '')
}



// WEBPACK FOOTER //
// client/utils/format.js